// Simple mock chat function
export const initializeChat = () => {
  return {
    sendMessage: async (message: string) => {
      // Simulate API delay
      await new Promise(resolve => setTimeout(resolve, 1000));
      return {
        response: {
          text: () => `I received your message: "${message}". How can I help you today?`
        }
      };
    }
  };
};

export default null; 